<template>
  <div class="panel-footer">
    <div class="footer-slot left">
      <v-btn
        v-if="homeViewMode !== viewModes.MIRROR"
        large
        color="secondary"
        @click="$emit('click')"
        :disabled="homeViewMode !== viewModes.CARD || !hasActiveFilters"
      >
        Limpar
      </v-btn>
    </div>

    <div class="footer-slot right">
      <div class="version">versão <span>2.0</span></div>
    </div>
  </div>
</template>

<script>
import { viewModes } from '@/utils/mappers';

export default {
  name: 'HomeNavigationDrawerFooter',
  props: {
    homeViewMode: undefined,
    hasActiveFilters: Boolean,
  },
  data() {
    return { viewModes };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/navigationDrawer-v2.scss';
@import '@/assets/scss/inputs.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/theme-v2.scss';
</style>
